import React from 'react';
import uniqueId from 'lodash/uniqueId';
import classNames from 'classnames';
import FakeLabel from './FakeLabel';

const oneMb = 1000000;

class InputFile extends React.Component {
  state = { text: this.props.text, errorMessage: null, internalError: false };
  id = uniqueId('file-input-');

  clear = (text = 'No file chosen') => {
    this.setState({ text });

    if (this.props.refProp && this.props.refProp.current) {
      this.props.refProp.current.value = '';
    }
  };

  handleChange = (e) => {
    const { maxFileSize = 1 } = this.props;
    const {
      target: { files },
    } = e;
    let fileName;
    if (files.length > 0) {
      if (files[0].size > oneMb * maxFileSize) {
        this.setState({
          internalError: true,
          errorMessage: `Selected file exceeds the ${maxFileSize}MB size requirement.`,
        });
      } else {
        this.setState({
          internalError: false,
          errorMessage: null,
        });
        fileName = files[0].name;
      }
    }
    this.setState({ text: fileName });
  };

  render() {
    const id = this.id;
    const { errorMessage, internalError, text } = this.state;
    const { refProp, name, error, info } = this.props;
    return (
      <React.Fragment>
        <FakeLabel required={this.props.required}>{this.props.label}</FakeLabel>
        {info ? <p className="file-input--info-text">{info}</p> : null}
        <div
          className={classNames('file-input', {
            'file-input--error': error || internalError,
          })}
        >
          <label htmlFor={id}>
            <span>{text}</span>
          </label>
          <input
            className="file-input--input-box"
            tabIndex={'0'}
            id={id}
            type="file"
            onChange={this.handleChange}
            name={name}
            ref={refProp}
          />
        </div>
        {(error || internalError) && <div className="file-input__error-message">{errorMessage || error}</div>}
        {this.props.restrictions && (
          <div className="file-input__restrictions">
            <small>{this.props.restrictions}</small>
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default InputFile;
